const locale = {
    placeholder: 'ಸಮಯ ಆಯ್ಕೆಮಾಡಿ',
    rangePlaceholder: ['ಪ್ರಾರಂಭ ಸಮಯ', 'ಅಂತಿಮ ಸಮಯ'],
};
export default locale;
